import { variantsFields } from "../fragments";

export default `
  ${variantsFields}
  
  query($variantsIds: [String!],$caseId:String,$articleId:String) {
    denouncedVariants(variantsIds: $variantsIds,articleId:$articleId,caseId:$caseId) {
    denouncedVariants{
      ...variantsFields
    }
}
  }
`;